import { render, staticRenderFns } from "./EditResellerServicePage.vue?vue&type=template&id=b27cc946"
import script from "./EditResellerServicePage.vue?vue&type=script&lang=js"
export * from "./EditResellerServicePage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports